enum ApiResponseHeader {
    RESPONSE_STATUS = 'response-status'
}

export default ApiResponseHeader;
